<template>
    <site-img
        :src="type === 'descBgImg' ? useBgSrc : ''"
        :style="{
            backgroundColor: type === 'color' ? descBgColor : '',
            paddingTop,
            marginBottom
        }"
        type="bgImg"
        class="md-team-desc performance-bgImg"
    >
        <div>
            <div class="description" v-if="title || introduction">
                <div
                    :class="{ introduction: true, 'mg-container': !fullColumn }"
                >
                    <div v-if="title" class="mg-title" v-html="formatFontSize(title, '--mg-title-size')"></div>
                    <div v-if="introduction" class="view-more-container" v-html="formatFontSize(introduction, 14)" style="font-family:var(--font-normal)"></div>
                </div>
            </div>
            <site-img
                :src="performancesBgType == 'image' ? performancesBgImg : ''"
                :style="{
                    backgroundColor:
                        performancesBgType == 'color'
                            ? performancesBgColor
                            : '',
                    color: performancesColor
                }"
                type="bgImg"
                class="list-content"
            >
                <ul
                    class="desc-list"
                    :class="{
                        'mg-container': !fullColumn,
                        [performanceLayout]: true
                    }"
                    v-if="performances.length"
                >
                    <li
                        class="item"
                        v-for="item in performances"
                        :key="item.label"
                    >
                        <i
                            v-if="item.icon"
                            class="iconfont"
                            :class="item.icon"
                        ></i>
                        <div class="performance-value">
                            <div class="inner">
                                <div class="number" v-html="item.value || '-'"></div>
                                <div class="text" v-html="item.label"></div>
                            </div>
                        </div>
                    </li>
                </ul>
            </site-img>
        </div>
    </site-img>
</template>
<script>
import common from '../index';
import { normal } from '../../defaultSpacing';
export default {
    mixins: [common],
    data: function() {
        return {
            performanceLayout: 'row',
            ...normal
        };
    },
    computed: {
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';

.md-team-desc.performance-bgImg {
    .description {
        padding-bottom: 36px;
        .introduction {
            font-size: 28px;
            .view-more-container {
                line-height: 1.5;
                font-size: 16px;
                font-family: var(--font-normal);
            }
        }
    }
    .list-content {
        color: #fff;
        .desc-list {
            display: flex;
            justify-content: space-around;
            flex-wrap: wrap;
            padding: 30px 0;
            align-items: center;
            .item {
                text-align: center;
                .iconfont {
                    &::before {
                        font-size: 50px;
                        display: inline-block;
                        margin-right: 8px;
                        margin-top: 2px;
                    }
                }
                .performance-value {
                    .number {
                        @include webkitBox(2);
                    }
                    .text {
                        @include ellipsis();
                    }
                }
            }
            &.row {
                .item {
                    .performance-value {
                        padding-top: 20px;
                        max-width: 235px;
                        .number {
                            font-size: 28px;
                            line-height: 36px;
                        }
                        .text {
                            font-size: 15px;
                            margin-top: 6px;
                            line-height: 20px;
                        }
                    }
                }
            }
            &.column {
                border: 1px solid #ececec;
                .item {
                    display: flex;
                    justify-content: flex-start;
                    text-align: left;
                    .iconfont {
                        &::before {
                            font-size: 42px;
                        }
                    }
                    .number {
                        font-size: 18px;
                    }
                    .text {
                        font-size: 13px;
                    }
                }
            }
        }
    }
    @media (max-width: 960px) {
        .list-content {
            .desc-list {
                height: auto;
                padding: 50px 0 50px 0;
                .item {
                    width: 50%;
                    justify-content: flex-start;
                    display: flex;
                    flex-direction: column;
                    align-items: left;
                }
            }
        }
    }
    @include media-600 {
        .description .introduction {
            font-size: 24px;
        }
        .list-content {
            .desc-list {
                .item {
                    line-height: 2;
                    margin-left: 45px;
                    flex-direction: row;
                    .performance-value {
                        text-align: left;
                        padding-top: 0px;
                        display: flex;
                        flex-direction: column;
                        justify-content: left;
                        margin-left: 25px;
                        .inner {
                            display: flex;
                            height: 100%;
                            flex-direction: column;
                            justify-content: center;
                        }
                    }
                    width: 100%;
                    display: flex;
                }
            }
        }
    }
}
</style>
